import {zoom, pdfZoom, norgeCoorAll, zoomAll, kartAPI, topoLayer} from '../config';
import * as kartView from '../views/kartView';
import * as searchView from '../views/searchView';
import {elements} from '../views/base';

export default class Kart {
  constructor() {
    this.map;
    this.marker;
    this.currentSave;
    this.latLng;
    this.bbox;

    // styrer om kartet kan klikkes på
    this.isEnabled = true;
  }

  getKart() {
    // initialize the map
    this.map = window.m = L.map('map').setView(norgeCoorAll, zoomAll);
    L.tileLayer(`${kartAPI}{z}/{y}/{x}.png`, {attribution: '<a href="http://www.kartverket.no/">Kartverket</a>'})
       .addTo(this.map);
    
    this.map.on('click', e => {
      if (this.isEnabled) {
        this.setMarker(e.latlng);
      }
    });

  }

  currentPos() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        const latLng = [position.coords.latitude, position.coords.longitude];
        this.currentLatLng = latLng;
        this.setMarker(latLng);
      });
    }
  }

  setMarker(latLng) {
    if (!this.marker) {
      this.marker = L.marker(latLng);
    }

    this.map.setView(latLng, zoom, {
      animate: true
    });

    this.marker.setLatLng(latLng).addTo(this.map);

    this.latLng = latLng;
    this.getBboxFromHiddenMap();

    searchView.clearList();
    searchView.clearInput();
    kartView.renderDmX(kartView.latLngToDmX(latLng));
    if (elements.sFormBtn.classList.contains("hide")) kartView.toggleHideBtn();  // for btn Lag nødplakat
  }

  disableMap() {
    this.isEnabled = false;
    this.map.dragging.disable();
    this.map.touchZoom.disable();
    this.map.doubleClickZoom.disable();
    this.map.scrollWheelZoom.disable();
  }

  enableMap() {
    this.isEnabled = true;
    this.map.dragging.enable();
    this.map.touchZoom.enable();
    this.map.doubleClickZoom.enable();
    this.map.scrollWheelZoom.enable();
  }

  getBboxFromHiddenMap() {
    if (!this.latLng) return;

    // Fast zoom og virtuell bredde — PDF viser alltid samme dekning uavhengig av skjermstørrelse
    const metersPerPx = 40075016.686 / (Math.pow(2, pdfZoom) * 256);
    const halfWidth = (1032 / 2) * metersPerPx;

    const center = L.CRS.EPSG3857.project(L.latLng(this.latLng));
    const sw = { x: center.x - halfWidth, y: center.y - halfWidth };
    const ne = { x: center.x + halfWidth, y: center.y + halfWidth };

    this.bbox = encodeURIComponent(`${sw.x},${sw.y},${ne.x},${ne.y}`);
  }
}
